import { useEffect, useState } from 'react';
import { LAYER_CONFIGS } from '../../constants/general';
import {
  calculateTotalDataLoad,
  DATA_LOAD_THRESHOLDS,
  getLoadStatus,
} from '../../utils/dataLoadCalculator';

export const useDataLoadMonitor = ({ layers, layerVisibility, zoom = 10 }) => {
  const [dataLoadInfo, setDataLoadInfo] = useState({
    totalSize: 0,
    totalComplexity: 0,
    layerBreakdown: {},
    visibleLayerCount: 0,
    loadStatus: { level: 'normal', message: '', color: 'green' },
  });

  const [hasShownWarning, setHasShownWarning] = useState(false);
  const [hasShownCritical, setHasShownCritical] = useState(false);

  useEffect(() => {
    const loadData = calculateTotalDataLoad(layers, layerVisibility, LAYER_CONFIGS, zoom);
    const status = getLoadStatus(loadData.totalSize);

    setDataLoadInfo({
      ...loadData,
      loadStatus: status,
    });

    // Show warning alert when crossing warning threshold
    if (
      loadData.totalSize >= DATA_LOAD_THRESHOLDS.WARNING &&
      loadData.totalSize < DATA_LOAD_THRESHOLDS.CRITICAL &&
      !hasShownWarning
    ) {
      setHasShownWarning(true);
      setHasShownCritical(false);
    }

    // Show critical alert when crossing critical threshold
    if (loadData.totalSize >= DATA_LOAD_THRESHOLDS.CRITICAL && !hasShownCritical) {
      setHasShownCritical(true);
      setHasShownWarning(false);
    }

    // Reset warnings when load drops below thresholds
    if (loadData.totalSize < DATA_LOAD_THRESHOLDS.WARNING) {
      setHasShownWarning(false);
      setHasShownCritical(false);
    }
  }, [layers, layerVisibility, hasShownWarning, hasShownCritical, zoom]);

  const resetWarnings = () => {
    setHasShownWarning(false);
    setHasShownCritical(false);
  };

  return {
    dataLoadInfo,
    hasShownWarning,
    hasShownCritical,
    resetWarnings,
  };
};
